import { render } from "./TelehealthCard.vue?vue&type=template&id=78ffe37d&scoped=true&ts=true&lang=pug"
import script from "./TelehealthCard.vue?vue&type=script&lang=ts"
export * from "./TelehealthCard.vue?vue&type=script&lang=ts"

import "./TelehealthCard.vue?vue&type=style&index=0&id=78ffe37d&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./TelehealthCard.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/teletherapy/telehealthCard.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fhome%2FTelehealthCard.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ffe37d"]])

export default __exports__